/**
 * Titled "needs attention" list panel for dashboard home pages — a nested
 * `<section>` so it picks up `.shell__content > section > section`'s
 * existing border-top spacer treatment for free, no new CSS needed for the
 * panel chrome itself, only for the row layout inside it.
 */
import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
import { EmptyState } from './EmptyState';

export interface DashboardPanelRow {
  id: number | string;
  to: string;
  label: React.ReactNode;
  value: React.ReactNode;
}

export interface DashboardPanelProps {
  title: string;
  rows: DashboardPanelRow[];
  emptyIcon: LucideIcon;
  emptyMessage: string;
}

export function DashboardPanel({
  title,
  rows,
  emptyIcon,
  emptyMessage,
}: DashboardPanelProps): React.JSX.Element {
  return (
    <section>
      <h3>{title}</h3>
      {rows.length === 0 ? (
        <EmptyState icon={emptyIcon} message={emptyMessage} />
      ) : (
        <ul className="panel-list">
          {rows.map((row) => (
            <li key={row.id}>
              <Link to={row.to} className="panel-row">
                <span className="panel-row__label">{row.label}</span>
                <span className="panel-row__value">{row.value}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default DashboardPanel;
